import RequestService from '../request-service';

/**
 * Get all available bet builder tabs,markets and outcomes for given sportcast fixture Id
 */
export default class BetBuilderTabsRequestService extends RequestService {
  constructor() {
    super();
    this.endpoint = '/GetMarketList';

    this.method = 'get';

    this.getParams = {
      key: '', // Client API key
      fixtureId: null, // The ID of the fixture to return markets for
      sport: null,
      culture: window.sportCastCulture || APP_SETTINGS.player.language, // Language to apply translations for. Can be blank for no translations
      returnFilters: true, // If true then all of the selections under each requested market label are returned
    };
  }
}
